export default function getParentOrError(element: HTMLElement): HTMLElement {
  if (!element.parentElement) {
    throw new Error('Expected element to have a parent')
  }
  return element.parentElement
}
